import { TabKeyType } from '../types';

export const tabAll = [
  { title: '最近分享', key: TabKeyType.RecentlyContact },
  { title: '组织架构', key: TabKeyType.Department },
  { title: '虚拟通讯录', key: TabKeyType.WorkLine },
  { title: '我的组', key: TabKeyType.Groups },
  { title: '我的联系人', key: TabKeyType.Contact },
];
export const tabNoGroups = [
  { title: '最近分享', key: TabKeyType.RecentlyContact },
  { title: '组织架构', key: TabKeyType.Department },
  { title: '虚拟通讯录', key: TabKeyType.WorkLine },
  { title: '我的联系人', key: TabKeyType.Contact },
];

export const searchTabAll = [
  { title: '全部', key: TabKeyType.All },
  { title: '联系人', key: TabKeyType.Contact },
  { title: '部门', key: TabKeyType.Department },
  { title: '组', key: TabKeyType.Groups },
];

export const searchTabNoGroups = [
  { title: '全部', key: TabKeyType.All },
  { title: '联系人', key: TabKeyType.Contact },
  { title: '部门', key: TabKeyType.Department },
];

export const getTabList = (params: any) => {
  const {
    isHasGroups = true,
    isSearch = false,
    isExternalContacts = false,
    isHasRecent = true,
    hasWorkLine = false,
    tabs = [],
  } = params;

  if (isSearch) {
    let list = isHasGroups ? searchTabAll : searchTabNoGroups;
    if (tabs.length !== 0) {
      list = [...tabs];
    }
    if (isExternalContacts && !hasWorkLine) {
      list = list.filter(
        item => item.key !== TabKeyType.Department
        //  &&item.key !== TabKeyType.WorkLine
      );
    }
    console.log(list, 'searchlists');
    return list;
  } else {
    let list = isHasGroups ? tabAll : tabNoGroups;
    if (tabs.length !== 0) {
      list = [...tabs];
    }
    if (!isHasRecent) {
      list = list.filter(item => item.key !== TabKeyType.RecentlyContact);
    }
    if (isExternalContacts) {
      list = list.filter(
        item => item.key !== TabKeyType.Department
        // &&item.key !== TabKeyType.WorkLine
      );
    }
    if (!hasWorkLine) {
      list = list.filter(item => item.key !== TabKeyType.WorkLine);
    }
    console.log(list, 'lists');
    return list;
  }
};
